import _ from 'underscore';

const textAssetFields = ['Headlines', 'LongHeadlines', 'Descriptions'];

/**
 * Checks if an asset group has at least 1 image or text asset.
 * @param {Object} data - Asset group data.
 * @returns {boolean} - True if asset group has at least 1 asset, false otherwise.
 */
export function hasAssetsInAssetGroup(data) {
  const ImageList = _.get(data, ['Images', 'ImageList']);
  if (!_.isEmpty(ImageList)) {
    // asset group has at least 1 image, return true
    return true;
  }

  for (let i = 0; i < textAssetFields.length; i += 1) {
    const key = textAssetFields[i];
    const values = _.values(data[key]);
    for (let j = 0; j < values.length; j += 1) {
      if (!_.isEmpty(values[j])) {
        // asset group has at least 1 text asset, return true
        return true;
      }
    }
  }

  return false;
}
